import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import StyledCard from "components/card/StyledCard";

import {greyishBlue600} from "assets/jss/main";

import MessageBubble from "./MessageBubble";

Transcript.propTypes = {
    messages: PropTypes.arrayOf(PropTypes.object).isRequired,
    shopperName: PropTypes.string,
};

/**
 * The thread, oldest first, scrolled to the latest message whenever one arrives.
 */
function Transcript({messages, shopperName}) {
    const bottomRef = useRef(null);
    const lastId = messages.length > 0 ? messages[messages.length - 1].id : null;

    useEffect(() => {
        bottomRef.current?.scrollIntoView({block: "end"});
    }, [lastId]);

    return (
        <StyledCard noHoverShadow style={{padding: 0, marginBottom: "16px"}}>
            <div style={{maxHeight: "60vh", minHeight: "240px", overflowY: "auto", padding: "16px", display: "flex", flexDirection: "column", gap: "8px"}}>
                {messages.length === 0 && (
                    <div style={{color: greyishBlue600, textAlign: "center", padding: "24px"}}>
                        <FormattedMessage id="personalShopper.conversation.noMessage" />
                    </div>
                )}
                {messages.map((message) => (
                    <MessageBubble key={message.id} message={message} shopperName={shopperName} />
                ))}
                <div ref={bottomRef} />
            </div>
        </StyledCard>
    );
}

export default Transcript;
